<template>
  <section class="free-video-search">
    <div class="free-video-search-input">
      <form action="javascript:;">
        <input type="search"
          placeholder="搜索"
          @change="handleInput"
          v-model="searchTag">
      </form>
    </div>
    <ul class="free-video-list">
      <free-video-item
        v-for="course in searchResult"
        :key="course.id"
        :data-source="course"
        :active="course.id === selectedCourse.id"
        :hightlight-word="searchTag"
        @select="handleSelectCourse(course)" />
    </ul>
  </section>
</template>

<script>
import FreeVideoItem from '../components/FreeVideoItem.vue'

import { mapState, mapActions, mapMutations } from 'vuex'
import { setTimeout } from 'timers'

export default {
  name: 'FreeVideoSearch',
  components: {
    FreeVideoItem
  },
  data () {
    return {
      searchTag: '',
      selectedCourse: {},
      inputDom: null
    }
  },
  computed: mapState({
    searchResult: state => state.freeVideo.searchResult
  }),
  created () {
    this['freeVideo/resetSearchResult']()
  },
  mounted () {
    this.inputDom = this.$el.querySelector('input')

    this.inputDom.focus()

    this.searchTag = decodeURIComponent(this.$route.query.search_word || '')
    if (this.searchTag) {
      this.handleInput()
    }
  },
  methods: {
    ...mapActions([
      'freeVideo/search'
    ]),
    ...mapMutations([
      'freeVideo/resetSearchResult',
      'freeVideo/remainSelectedCourse'
    ]),
    handleInput (e) {
      this['freeVideo/search'](this.searchTag)
    },
    handleSelectCourse (course) {
      this.inputDom.blur()

      setTimeout(() => {
        this['freeVideo/remainSelectedCourse'](course)
        this.$router.push(`/free_video/main/${course.id}`)
      }, 300)
    }
  }
}
</script>

<style lang="scss">
  @import '../style/main';

  $global-width: 750;

  .free-video-search {
    padding: rem(16) rem(30);

    &-input {
      & input {
        display: block;
        box-sizing: border-box;
        padding: rem(20) 0 rem(20) rem(68);
        width: 100%;
        border-radius: 6px;
        background: {
          color: #eee;
          image: url('../assets/images/free-video-search-icon.png');
          repeat: no-repeat;
          position: rem(30) center;
          size: rem(28) rem(28);
        }
        font-size: rem(28);
      }
    }
  }

  $global-width: 720;
</style>
